import { combineReducers } from 'redux';
import checkRecaptchaReducer from './checkRecaptchaReducer';
import updateAdminOrgRecaptchaReducer from './updateAdminOrgRecaptchaReducer';

export default combineReducers({
  checkRecaptcha: checkRecaptchaReducer(),
  updateAdminOrgRecaptcha: updateAdminOrgRecaptchaReducer(),
});
